<template>

    <div class="container">

        <div class="top-wrap">

            <div class="handle-box-search">



                <el-row class="head-search">


                    <el-col :span="12" style="margin-bottom: 10px;">
                        <span class="title">起止时间</span>

                        <el-date-picker v-model="search_time" type="daterange" range-separator="-" start-placeholder="开始日期"
                                        end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" @change="timeChange"
                                        style="width: 200px;">
                        </el-date-picker>
                    </el-col>


                    <el-col :span="12" style="margin-bottom: 10px;">
                        <span class="title">订单号查询</span>

                        <el-input v-model="search_data.trade_no" style="width: 200px;"></el-input>
                    </el-col>



                    <el-col :span="12" style="margin-bottom: 10px;">
                        <span class="title">手机号查询</span>

                        <el-input v-model="search_data.phone" style="width: 200px;" maxlength="11"></el-input>
                    </el-col>



                </el-row>







                <el-button type="primary" icon="el-icon-search" @click="searchdriverRechargeLists">搜索</el-button>
                <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
                <el-button :icon="!progress_show?'el-icon-setting':'el-icon-loading'" @click="toExport" :disabled="progress_show">{{progress_show?'正在导出...':'导出'}}</el-button>

            </div>


            <div class="wallet-wrap">

                <div class="top">

                    <h4> <span></span>服务费余额 </h4>

                    <p>￥{{total.balance_amount}}</p>

                </div>

                <!-- <div class="main">

                    <div class="first">
                        <p>￥{{total.insurance_amount}}</p>
                        <span>保险金总额</span>
                    </div>
                    <div class="last">
                        <p>￥{{total.frozen_amount}}</p>
                        <span>冻结金总额</span>
                    </div>

                </div> -->

            </div>

        </div>
        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">


            <el-table-column prop="phone" label="用户手机号">
            </el-table-column>

            <el-table-column prop="trade_no" label="充值订单编号">
            </el-table-column>


            <el-table-column prop="amount" label="充值金额">
            </el-table-column>



            <el-table-column prop="pay_channel" label="充值方式">
            </el-table-column>

            <el-table-column prop="time_stamp" label="充值时间">
            </el-table-column>







        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>


    </div>

</template>

<script>
    var _this;
    export default {


        data() {
            return {


                search_time: '',

                // 存放表格数据
                tableData: [],

                excelData: [],

                excelHead: [],

                progress_show: false,

                total:{
                    balance_amount: '',
                    frozen_amount: '',
                    insurance_amount: '',
                },

                //翻页数据
                search_data: {
                    page: 1,
                    limit: 10,
                    complete_fixed_array: '',
                    trade_no:'',
                    phone:''
                },

                result_data: [],
                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    },

                },
            };
        },
        created() {
            _this = this;

            _this.driverRechargeLists()
        },

        methods: {

            toExport(){
                _this.getExcelData();
            },
            // 导出excel方法
            exportData() {
                const {
                    export_json_to_excel
                } = require('@/vendor/Export2Excel');
                const tHeader = ['用户手机号','充值订单编号','充值金额', '充值方式', '充值时间'];
                const filterVal = ['phone','trade_no','amount','pay_channel','time_stamp'];
                const list = this.excelData;
                const data = this.formatJson(filterVal, list);
                export_json_to_excel(tHeader, data, 'fileName');
            },

            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

            getExcelData(){
                _this.$post(
                    "/statistics/getDriverRechargeDetail",
                    _this.search_data
                ).then(res => {

                    _this.progress_show = true;

                    if (this.$route.path == '/getDriverRechargeDetail') {


                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.result.length; i++) {

                            _this.excelData.push({
                                'phone': res.data.result[i].phone,
                                'trade_no': res.data.result[i].trade_no,
                                'phone': res.data.result[i].phone,
                                'amount': res.data.result[i].amount,
                                'pay_channel': res.data.result[i].description,
                                'time_stamp': res.data.result[i].time_stamp,

                            });


                        }



                        if (res.data.page * res.data.limit < res.data.count) {

                            _this.search_data.page = res.data.page + 1;


                            _this.getExcelData();

                        } else {

                            // console.log(_this.excelData);

                            // 将数据导出execl
                            _this.exportData();

                            _this.search_data.page = 1;

                            // 清空数据
                            _this.excelData = [];

                            _this.progress_show = false;


                        }

                    } else {

                        _this.progress_show = false;

                    }



                }).catch((err) => {

                })

            },



            timeChange(val) {
                if(val !== null){
                    _this.search_data.complete_fixed_array = JSON.stringify(['between'].concat(val));

                }else{
                    _this.search_data.complete_fixed_array = ''
                }

            },
            searchdriverRechargeLists() {


                _this.search_data.page = 1;
                _this.driverRechargeLists();

            },
            // 搜索司机日志列表
           driverRechargeLists() {

                _this.$post(
                    "/statistics/getDriverRechargeDetail",
                    _this.search_data,
                    _this.search_rules
                )
                    .then(res => {


                        // 将请求的数据存放到表格数据数组中
                        _this.tableData = res.data.result;
                        _this.result_data = res.data;

                    }).catch((err) => {

                })

                _this.getDriverRechargeTotal()

            },
            getDriverRechargeTotal(){
                _this.$post(
                    "/statistics/getDriverRechargeTotal",
                    _this.search_data,
                    _this.search_rules
                )
                    .then(res => {


                        _this.total = res.data;


                    }).catch((err) => {

                })

            },
            //翻页组件的回调
            pages_function(search_data) {

                //赋值
                _this.search_data = search_data;
                //初始化列表
                _this.driverRechargeLists();

            },


            // 刷新按钮
            refresh() {
                this.$router.go(0);
            },

        }
    };
</script>

<style scoped>

    .top-wrap{
        display: flex;
        justify-content: space-between;
    }

    .wallet-wrap{
        width: 40%;
        border: 1px solid #E3E3E3;
        background: #FFFFFF;
        margin-bottom: 20px;
        padding: 14px 30px;
        box-sizing: border-box;
    }
    .wallet-wrap .top{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .wallet-wrap .top h4{
        font-size: 14px;
        color: #737373;
        font-weight: 400;
    }
    .wallet-wrap .top span{
        display: inline-block;
        width: 2px;
        height: 13px;
        background: #05C0AB;
        margin-right: 4px;
    }
    .wallet-wrap .top p{

        font-size: 24px;
        font-weight: 400;
        color: #05C0AB;
    }
    .wallet-wrap .main{
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
    }
    .wallet-wrap .main>div{
        width: 48%;
        height: 90px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        padding: 20px 20px 20px 0;
        box-sizing: border-box;
    }
    .wallet-wrap .main>div p{

        font-size: 20px;
        color: #FFFFFF;
        font-weight: 400;
        text-align: right;
    }
    .wallet-wrap .main>div span{
        display: block;
        margin-top: 10px;
        text-align: right;
        font-size: 12px;
        color: #FFFFFF;
        font-weight: 400;
    }
    .wallet-wrap .main .first{
        background-image: url("../../../assets/consumerRecharge-1.png");
    }
    .wallet-wrap .main .last{
        background-image: url("../../../assets/consumerRecharge-2.png");
    }
    .handle-box-search{
        width: 55%;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
    }

    .el-form-item__content span {
        display: inline-block;
        width: 100%;
        word-wrap: break-word;
        white-space: normal;
    }
</style>
